import type { FC } from 'react';
import { motion } from 'framer-motion';

interface RippleEffectProps {
  x: number;
  y: number;
  onComplete?: () => void;
}

export const RippleEffect: FC<RippleEffectProps> = ({ x, y, onComplete }) => {
  return (
    <motion.div
      className="pointer-events-none absolute rounded-full border-2 border-yellow-300/60"
      style={{
        left: x,
        top: y,
        width: 20,
        height: 20,
        marginLeft: -10,
        marginTop: -10
      }}
      initial={{ scale: 0, opacity: 0.8 }}
      animate={{ scale: 3.5, opacity: 0 }}
      transition={{ duration: 0.55, ease: 'easeOut' }}
      onAnimationComplete={onComplete}
    />
  );
};

